import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Input } from '@fortem-monorepo/react-ui'

export interface LongNameFormFieldProps {
  placeholder?: string
}

export const LongNameFormField: React.FC<LongNameFormFieldProps> = ({ placeholder }) => {
  const { control, register } = useFormContext<{ long_name: string }>()

  return (
    <FormField
      name="long_name"
      control={control}
      render={() => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Long Name</FormLabel>
              <FormError />
            </div>
            <Input {...register('long_name')} placeholder={placeholder ?? 'Enter a long name...'} />
          </FormItem>
        )
      }}
    />
  )
}
